import { ref } from 'vue'

export const usePromiseLoader = () => {
  const isLoading = ref(false)

  const execute = async <T>(promise: Promise<T>): Promise<T> => {
    isLoading.value = true
    const response = await promise
    isLoading.value = false
    return response
  }

  const executeCallback = async (callback: () => Promise<void>) => {
    isLoading.value = true
    await callback()
    isLoading.value = false
  }

  return { isLoading, execute, executeCallback }
}
